/**
 * 发票预览弹窗（全视角通用）
 * 传入发票对象即可弹出数电票图片预览。
 */

import { Badge, money, Button } from './ui'

export interface InvoicePreviewData {
  invoice_id: string
  invoice_no: string | null
  order_id: string
  invoice_category: string
  amount: string
  tax_rate: string
  remark: string
  pdf_url: string | null
  status: string
}

export function InvoicePreviewModal({ invoice, onClose }: { invoice: InvoicePreviewData; onClose: () => void }) {
  const catLabel = invoice.invoice_category === 'GOODS' ? '商品票(13%)' : '服务费票(6%)'
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 24 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: 8, maxWidth: 440, maxHeight: '90vh', overflow: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderBottom: '1px solid #e5e7eb' }}>
          <strong>{catLabel} 预览</strong>
          <Button size="sm" variant="default" onClick={onClose}>关闭</Button>
        </div>
        {invoice.pdf_url && invoice.status === 'ISSUED' ? (
          <img src={invoice.pdf_url} alt={invoice.invoice_no ?? ''} style={{ width: '100%', display: 'block' }} />
        ) : (
          <div style={{ height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#888' }}>无预览（{invoice.status}）</div>
        )}
        <div style={{ padding: 12, fontSize: 12, color: '#666' }}>
          <div>发票号：{invoice.invoice_no ?? '-'} <Badge status={invoice.status} /></div>
          <div>订单：{invoice.order_id}</div>
          <div>金额：{money(invoice.amount)} · 税率：{(Number(invoice.tax_rate) * 100).toFixed(0)}%</div>
          <div>备注：{invoice.remark}</div>
        </div>
      </div>
    </div>
  )
}
